"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessAddUserBodyToJSON = exports.BusinessAddUserBodyFromJSONTyped = exports.BusinessAddUserBodyFromJSON = void 0;
var _1 = require("./");
function BusinessAddUserBodyFromJSON(json) {
    return BusinessAddUserBodyFromJSONTyped(json, false);
}
exports.BusinessAddUserBodyFromJSON = BusinessAddUserBodyFromJSON;
function BusinessAddUserBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': json['email'],
        'permissions': (json['permissions'].map(_1.BusinessPermissionFromJSON)),
    };
}
exports.BusinessAddUserBodyFromJSONTyped = BusinessAddUserBodyFromJSONTyped;
function BusinessAddUserBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'permissions': (value.permissions.map(_1.BusinessPermissionToJSON)),
    };
}
exports.BusinessAddUserBodyToJSON = BusinessAddUserBodyToJSON;
